"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartType = void 0;
// eslint-disable-next-line no-shadow
var ChartType;
(function (ChartType) {
    ChartType["AREA3DSTACK"] = "area3dstack";
    ChartType["BAR3DSTACK"] = "bar3dstack";
    ChartType["BAR3DGROUP"] = "bar3dgroup";
    ChartType["LINE3DGROUP"] = "line3dgroup";
    ChartType["TABLE3D"] = "table3d";
    ChartType["BAR2D"] = "bar2d";
    ChartType["PIE2D"] = "pie2d";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
exports.default = ChartType;
